// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2ASFa","label":"Section_label__VeSsC","contentWrap":"Section_contentWrap__1cchR","footer":"Section_footer__1Db9m","footerInner":"Section_footerInner__OSUzz"};